/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagBIcon20Solid = forwardRef('FlagBIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 3.5v15.25a1.25 1.25 0 1 0 2.5 0v-5.363c1.673-.645 3.314-.484 5.004.481 2.635 1.506 5.339 1.51 7.974.01a1 1 0 0 0 .522-.897V3.018c.014-.765-.852-1.27-1.51-.878-2.022 1.15-3.973 1.147-5.994-.008C7.95.676 5.337.625 2.786 1.977 2.363 2.2 2 2.642 2 3.5Z" })));
});
